import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const footer = css`
  position: relative;
  grid-area: footer;
  z-index: 20;
  font-weight: 800;
  display: flex;
  flex-direction: column;
  gap: 0.75em;
  align-self: flex-end;
  font-size: 12px;
  @container feed (width > 300px) {
    font-size: 14px;
  }
`;

export const providers = css`
  display: flex;
  gap: 0.75em;
`;

export const availableIn = css`
  font-weight: 700;
  font-size: 15px;
`;

export const comment = css`
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  padding: 0.75em 1em;
  margin: 0 2.5em;
  font-size: 12px;
  @container feed (width > 300px) {
    font-size: 14px;
    margin: 0 3.5em;
  }
`;

export const providerLogo = css`
  width: 40px;
  height: 40px;
  &:hover {
    box-shadow: ${theme.elevation.base};
  }
  img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
`;
